<template>
  <section class="expertise-wrapper section-wrapper gray-bg" id="expertise">

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title">
            <h2>Work Experience</h2>
          </div>
        </div>
      </div>
      <!-- .row -->
      <TimeLine v-for="(timeItem, timeIdx) in timeline_data" :key="timeIdx"
        v-bind:year="timeItem.year"
        v-bind:list="timeItem.list"
      />
    </div>
    <!--.container-fluid-->
  </section>
  <!-- .expertise-wrapper -->

</template>
<script>
import TimeLine from './general/timeline-vuejs/timeline-vuejs'

export default {
  components: {
    TimeLine,
  },
  data() {
     return {
       timeline_data: [
         {
           year: 2025,
           list:
           [
             {
               day: 1,
               month: "November",
               companyName: "Allianz",
               companyDescription: "AI, Infrastructure and Integration Architect · 11/2025 – 09/2026 · Madrid",
               web: "https://www.allianz.es",
               text:`<p>Banking and insurance sector: cloud-native architectures, infrastructure, integrations and enterprise delivery patterns in regulated financial environments.</p>
                      <ul>
                        <li>Solution architectures, integrations, APIs and cloud/platform patterns</li>
                        <li>RAG architectures: enterprise document retrieval, embeddings, vector search and LLM-based generation</li>
                        <li>Integration of AI services with Python APIs, microservices and enterprise platforms</li>
                        <li>Kubernetes/OpenShift, CI/CD, security and observability</li>
                      </ul>
                      <p><strong>Technologies:</strong> Python, Kubernetes, OpenShift, AWS, Azure, Terraform, Ansible, MLOps, CI/CD</p>`
             },
             {
               day: 1,
               month: "February",
               companyName: "Alisys",
               companyDescription: "Team Lead - Robotic Platform · 02/2025 – 05/2025 · Gijón",
               text:`<p>Led an industrial robotic platform team and European projects, defining architecture and integrating robotics with IoT.</p>
                      <ul>
                        <li>Cloud-native robotic platform on OpenShift, CI/CD with GitLab and ArgoCD, RBAC, TLS and pod security</li>
                        <li>AI-model capabilities and NLP/LLM interaction for conversational human-to-system interfaces</li>
                      </ul>
                      <p><strong>Technologies:</strong> OpenStack, OpenShift, Prometheus, Grafana, Loki, Tempo, Ceph, RabbitMQ, Keycloak, ROS, Node.js, Angular</p>`
             }
           ]
         },
         {
           year: 2024,
           list:
           [
             {
               day: 1,
               month: "August",
               companyName: "Amazon (Freelance)",
               companyDescription: "AWS Architect · 08/2024 – 12/2024 · Madrid",
               text:`<p>Led architecture and development of an IoT energy-management system for buildings, integrating Edge and AWS serverless components.</p>
                      <ul>
                        <li>Hybrid Cloud/Edge architecture and IoT data pipelines</li>
                        <li>IAM, Security Groups, VPN and IaC with Terraform and AWS CDK</li>
                        <li>Led the technical team; CI/CD and AI/ML models for energy efficiency</li>
                      </ul>
                      <p><strong>Technologies:</strong> AWS IoT Core, Lambda, DynamoDB, Timestream, Python, CDK, Terraform, Ansible</p>`
             },
             {
               day: 1,
               month: "April",
               companyName: "Renfe (Freelance)",
               companyDescription: "Software and Data Architect · 04/2024 – 07/2024 · Madrid",
               text:`<p>Graph-based platform for security-incident analysis, linking operational data in Neo4j and deploying microservices on OpenShift/Azure.</p>
                      <p><strong>Technologies:</strong> Neo4j, OpenShift, Azure, Databricks, Azure Data Factory, Python, PySpark</p>`
             }
           ]
         },
         {
           year: 2023,
           list:
           [
             {
               day: 1,
               month: "November",
               companyName: "Repsol (Freelance)",
               companyDescription: "Software Architect · 11/2023 – 03/2024 · Madrid",
               text:`<p>Scalable analytics architecture for oil &amp; gas production forecasting and infrastructure choke-point detection.</p>
                      <p><strong>Technologies:</strong> Azure Data Factory, Azure Functions, SQL, Oracle, Python, ML/AI models</p>`
             },
             {
               day: 1,
               month: "January",
               companyName: "Indra (Freelance)",
               companyDescription: "Architect and Team Lead · 01/2023 – 11/2023 · Madrid",
               text:`<p>Led the redesign of a legacy C++ energy transmission control system into a cloud-native SCADA platform using Python and Go.</p>
                      <ul>
                        <li>Microservices on Kubernetes/OpenShift across hybrid cloud</li>
                        <li>ArgoCD, Terraform, Ansible and full observability (Prometheus, Grafana, Loki, Tempo)</li>
                        <li>DevOps, MLOps and AIOps practices; IoT/Edge integration</li>
                      </ul>`
             }
           ]
         },
         {
           year: 2022,
           list:
           [
             {
               day: 1,
               month: "April",
               companyName: "Nexiona (Freelance)",
               companyDescription: "CTO / Tech Lead / Solution Architect · 04/2022 – 01/2023 · Barcelona",
               text:`<p>Led a multidisciplinary team of up to 20 people delivering IoT and Smart Factory projects and evolving the company IoT platform.</p>
                      <p><strong>Technologies:</strong> Kubernetes, OpenShift, ArgoCD, GitLab CI/CD, Keycloak, Prometheus, Grafana, Azure Data Factory, Power BI, Edge Computing</p>`
             },
             {
               day: 1,
               month: "January",
               companyName: "LetMePark (Freelance)",
               companyDescription: "Solution Architect · Madrid",
               text:`<p>Voice-enabled parking reservation platform compatible with Alexa, Google Assistant and Siri, deployed as microservices on OpenShift/AWS.</p>
                      <p><strong>Technologies:</strong> OpenShift, AWS, Keycloak, GitLab CI/CD, Vue.js, Node.js, Python, payment gateways</p>`
             }
           ]
         },
         {
           year: 2020,
           list:
           [
             {
               day: 1,
               month: "February",
               companyName: "Freelance",
               companyDescription: "Diferents Companies",
               web: "https://www.drouiz.com",
               text:` 
                      <h3>Skils</h3>
                      <p> Diferentes Skills and habilities. Arquitect Cloud & Data and IoT projects"
<h3>Projects: </h3>

<h4>Accenture</h4>
<p><strong>Billing Energy SaaS</strong></p>
<p>Role: Project Director and Architect</p>
<p>Led a team of 10 members, working on Front-End, Back-End, and Data components.</p>
<p>Developed primarily using AWS, Angular, and Business Intelligence (BI) tools.</p>
<p>This project focused on billing systems with heavy use of PySpark, Lambda architecture, and BI solutions.</p>

                      `
             }
           ]
         },
         {
           year: 2019,
           list:
           [
             {
               day: 1,
               month: "Nobember",
               companyName: "Santander Bank",
              companyDescription: "Universia (The most important Spain and LATAN scholarships web)",
               web: "https://www.universia.net",
               text:` <ul>
                        <li>Back-End (NodeJs)</li>
                        <li>Kubernetes & Microservices</li>
                        <li>Azure</li>
                        <li>MongoDB</li>
                        <li>ElasticSearch</li>
                      </ul> `
             }
           ]
         },
         {
           year: 2018,
           list:
           [
             {
               day: 15,
               month: "Aug",
               companyName: "Telefonica",
              companyDescription: "The Biggest Spanish Telco",
               web: "https://www.telefonica.com/",
               text:` <ul>
                        <li>Back-End (NodeJS and Python) and Microservices developer</li>
                        <li>VueJS frontend Developer </li>
                        <li>Django Back-Ends </li>
                        <li>SQL (SQL Server, MySQL) and NoSQL (Mongo, Neo4J) databases</li>
                        <li>Routers, Switchs and Networks</li>
                      </ul> `
             }
           ]
         },
         {
           year: 2013,
           list:
           [
             {
               day: 1,
               month: "Janu",
               companyName: "Drouiz",
              companyDescription: "IoT company specialist",
               text: `    <ul>
                          <li>Managing up to 10 people.</li>
                          <li>Electronics Projects and IoT programming</li>
                          <li>Energy Efficiency Projects.</li>
                          <li>Full Stack IoTs Dashboards (React, Angular, Vue)</li>
                          <li>Odoo framework (ERP and CRM Python based) </li>
                          <li>SQL (SQL Server, MySQL) and NoSQL (Mongo, Redis) databases
                          <li>PHP and MySQL projects </li>
                          </ul>`,
               web: "https://www.drouiz.com"
             }
           ]
         },
         {
           year: 2012,
           list:
           [
             {
               day: 1,
               month: "June",
               companyName: "E-CAT (France)",
               companyDescription: "Company dedicated to the manufacture of machinery for chicken farming",
               text: `      <ul>
                            <li>Maintenance: Consulting with &nbsp;English, Portuguese and Spanish speaking clients &nbsp;of the correct &nbsp;equipment to&nbsp;acquired.</li>
                            <li>Development of connections and electrical drawings using EPLAN-</li>
                            <li>Programming of PLCs in these machines.</li>                       
                            <li>Electrical Economic Survey.</li>
                            </ul>`,
               web: "https://www.ecat-id.com/"
             }
           ]
         },
         {
           year: 2009,
           list:
           [
             {
               day: 1,
               month: "Dec.",
               companyName: "Selfemployed",
               companyDescription: "Electrical and building services engineer, automatizations and electronics",
               text: `<ul>
                    <li>Projects desing</li>
                    <li>Managing up to 10 people.</li>
                    <li>Low-voltage electrical installations</li>
                    <li>Alarm systems, CCTV and security</li>
                    <li>Industrial automation</li>
                    <li>Energy efficiency.</li>
                    </ul>`
             }
           ]
         },
         {
           year: 2007,
           list:
           [
             {
               day: 1,
               month: "Jun.",
               companyName: "TYPSA",
               companyDescription: "Engineering Consultant",
               text: `
               <ul>
               <li>General low voltage installations.</li>
               <li>Industrial facilities and automation.</li>
               <li>Managing up to 10 people.</li>
               <li>Dealing with clients.</li>
               </ul>

                <a href="http://logitek.es/wp-content/uploads/2016/03/Aena_historia_exito_Wonderware.pdf">
                Article about Barcelona Inernational Airport Speaking about CENAT (Spanish)
                </a>`
             }
           ]
         },
         {
           year: 1999,
           list:
           [
             {
               day: 1,
               month: "Jan.",
               companyName: "Family Bussines",
               companyDescription: "Working with Father Boss",
               text: `
               <ul>
               <li>Electrician.</li>
               <li>Industrial facilities.</li>
               <li>Low Voltage building services.</li>
               <li>Not permament job, studing combining.</li>
               </ul>`
             }
           ]
         }
       ]
     }
   }
 }



</script>

<style scoped>
/*
P.S: if you like my content maybe you will become a donator and donate some money? That helps me to create new awesome materials. https://www.paypal.me/melnik909
*/

.timeline{
  --uiTimelineMainColor: var(--timelineMainColor, #222);
  --uiTimelineSecondaryColor: var(--timelineSecondaryColor, #fff);

  position: relative;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.timeline:before{
  content: "";
  width: 4px;
  height: 100%;
  background-color: var(--uiTimelineMainColor);

  position: absolute;
  top: 0;
}

.timeline__group{
  position: relative;
}

.timeline__group:not(:first-of-type){
  margin-top: 4rem;
}

.timeline__year{
  padding: .5rem 1.5rem;
  color: var(--uiTimelineSecondaryColor);
  background-color: var(--uiTimelineMainColor);

  position: absolute;
  left: 0;
  top: 0;
}

.timeline__box{
  position: relative;
}

.timeline__box:not(:last-of-type){
  margin-bottom: 30px;
}

.timeline__box:before{
  content: "";
  width: 100%;
  height: 2px;
  background-color: var(--uiTimelineMainColor);

  position: absolute;
  left: 0;
  z-index: -1;
}

.timeline__date{
  min-width: 65px;
  position: absolute;
  left: 0;

  box-sizing: border-box;
  padding: .5rem 1.5rem;
  text-align: center;

  background-color: var(--uiTimelineMainColor);
  color: var(--uiTimelineSecondaryColor);
}

.timeline__day{
  font-size: 2rem;
  font-weight: 700;
  display: block;
}

.timeline__month{
  display: block;
  font-size: .8em;
  text-transform: uppercase;
}

.timeline__post{
  padding: 1.5rem 2rem;
  border-radius: 2px;
  border-left: 3px solid var(--uiTimelineMainColor);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 1px 2px 0 rgba(0, 0, 0, .24);
  background-color: var(--uiTimelineSecondaryColor);
}

@media screen and (min-width: 641px){

  .timeline:before{
    left: 30px;
  }

  .timeline__group{
    padding-top: 55px;
  }

  .timeline__box{
    padding-left: 80px;
  }

  .timeline__box:before{
    top: 50%;
    transform: translateY(-50%);
  }

  .timeline__date{
    top: 50%;
    margin-top: -27px;
  }
}

@media screen and (max-width: 640px){

  .timeline:before{
    left: 0;
  }

  .timeline__group{
    padding-top: 40px;
  }

  .timeline__box{
    padding-left: 20px;
    padding-top: 70px;
  }

  .timeline__box:before{
    top: 90px;
  }

  .timeline__date{
    top: 0;
  }
}

.timeline{
  --timelineMainColor: #4557bb;
  font-size: 16px;
}

@media screen and (min-width: 768px){

  html{
    font-size: 62.5%;
  }
}

@media screen and (max-width: 767px){

  html{
    font-size: 55%;
  }
}

/*
* demo page
*/

body{
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Open Sans, Ubuntu, Fira Sans, Helvetica Neue, sans-serif;
  font-size: 1.6rem;
  color: #222;

  background-color: #f0f0f0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}

p{
  margin-top: 0;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

p:last-child{
  margin-bottom: 0;
}

.page{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.page__demo{
  flex-grow: 1;
}

.main-container{
  max-width: 960px;
  padding-left: 2rem;
  padding-right: 2rem;

  margin-left: auto;
  margin-right: auto;
}

.page__container{
  padding-top: 30px;
  padding-bottom: 30px;
  max-width: 800px;
}

.footer{
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 1.4rem;
}

.footer__link{
  text-decoration: none;
  color: inherit;
}

@media screen and (min-width: 361px){

  .footer__container{
    display: flex;
    justify-content: space-between;
  }
}

@media screen and (max-width: 360px){

  .melnik909{
    display: none;
  }
}
</style>
